import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { addPatientImmunization, setPatientImmunizations } from '../store/patientImmunizations.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getPatientImmunizations(pcrDoc: IPcr) {
  const patientImmunizations = pcrDoc.patient?.patientImmunizations
  if (patientImmunizations && Object.keys(patientImmunizations)?.length !== 0) {
    yield put(setPatientImmunizations(patientImmunizations))
  }
  if (patientImmunizations?.immunizations?.length === 0) {
    yield put(addPatientImmunization())
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getPatientImmunizations, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPatientImmunizations.saga.ts: ${e}`))
  }
}

export function* getPatientImmunizationsSaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
